import type { Products } from "../types"

export const products: Products = new Map([
  [
    "euler-unichain",
    {
      name: "Euler Unichain",
      description:
        "A market tailored to borrowing stable assets against blue chip crypto assets. Governed by Euler DAO.",
      entity: ["euler-dao", "gauntlet"],
      url: "",
      vaults: [
        "0x1f3134C3f3f8AdD904B9635acBeFC0eA0D0E1ffC",
        "0x54ff502df96CD9B9585094EaCd86AAfCe902d06A",
        "0xe36DA4Ea4D07E54B1029eF26A896A656A3729f86",
        "0x45b41B20B11cD2e71A6BF3021bdbc3F8aFEa5538",
        "0x59215f65cB2F5Ddf048eFA8136Fc2C19F9A6C416",
        "0x6eAe95ee783e4D862867C4e0E4c3f4B95AA682Ba",
        "0xD49181c522eCDB265f0D9C175Cf26FFACE64eAD3",
        "0x576f68B0395738AEF01811b8F8EeC25302829F1d",
        "0x7650D7ae1981f2189d352b0EC743b9099D24086F",
        "0x5d2511C1EBc795F4394f7f659f693f8C15796485",
      ],
    },
  ],
  [
    "euler-unichain-lst",
    {
      name: "Euler Unichain LST",
      description:
        "A market tailored to borrowing WETH and LST assets. Governed by Euler DAO.",
      entity: ["euler-dao", "gauntlet"],
      url: "",
      vaults: [
        "0x6Bc1f97f96Dd6834A86aCf412B77C9F464419436",
        "0xCF28A176021e6906C359d1777041245d9Fda076D",
        "0xe6806beA4eCDE065bB757c35032f2c625848D8e8",
        "0x25e2ef0f957B61cdd26BBE954AFD5806A9DaDe49",
      ],
    },
  ],
  [
    "alphagrowth-unichain",
    {
      name: "AlphaGrowth Unichain Vaults",
      description:
        "A market tailored to borrowing against blue chip crypto assets. Governed by AlphaGrowth.",
      entity: ["alphagrowth"],
      url: "https://alphagrowth.io/",
      vaults: [
        "0x218c9e961fC5f6c8280bA160365FAbe8A53Ec6E5",
        "0x5ADAde21c703912547BFc8952fe1B52f09437E2A",
      ],
    },
  ],
])
